module.exports = __webpack_public_path__ + "static/media/krishna-chandak.b5732d23.jpeg";